import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { AuthService } from '@pecan/core';
import { Router } from '@angular/router';
import { MatToolbar, MatToolbarRow } from '@angular/material/toolbar';
import { MatButton } from '@angular/material/button';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatToolbar, MatToolbarRow, MatButton, MatMenuTrigger, MatMenu, MatMenuItem, TranslatePipe],
    selector: 'app-header-menu',
    styleUrls: ['./header-menu.component.scss'],
    templateUrl: './header-menu.component.html',
})
export class HeaderMenuComponent {
    private _authService: AuthService = inject(AuthService);

    private _router: Router = inject(Router);

    public logout(): void {
        this._authService.logout();
    }

    public goToProfile(): void {
        this._router.navigate(['/profile']);
    }
}
